// src/components/homepage/HomeFooter.js
import { Link } from "react-router-dom";
import { useState } from "react";
import { Mail } from "lucide-react";
import { useCookiePreferences } from "../../context/CookieContext";

function HomeFooter() {
  const [showEmail, setShowEmail] = useState(false);
  const { openPreferences } = useCookiePreferences();

  return (
    <footer className="bg-slate-900 text-white py-8">
      <div className="relative isolate max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 pb-8">
          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-2 text-base">Resources</h4>
            <ul className="space-y-1.5 text-sm text-slate-300">
              <li>
                <Link to="/blog" className="hover:text-white transition">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/submit-problem" className="hover:text-white transition">
                  Submit Problem
                </Link>
              </li>
              <li>
                <Link to="/signup" className="hover:text-white transition">
                  Become an Expert
                </Link>
              </li>
              <li>
                <Link to="/login" className="hover:text-white transition">
                  Login
                </Link>
              </li>
              <li>
                <Link to="/signup" className="hover:text-white transition">
                  Sign Up
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Info */}
          <div>
            <h4 className="font-semibold mb-2 text-base">Company Info</h4>
            <ul className="space-y-1.5 text-sm text-slate-300">
              <li>
                <button
                  onClick={() => setShowEmail(!showEmail)}
                  className="hover:text-white transition text-left"
                >
                  Contact
                </button>
                {showEmail && (
                  <p className="mt-1 text-blue-400 text-xs">
                    skillsyncs@outlook.com
                  </p>
                )}
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition">
                  About
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition">
                  Terms
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/legal" className="hover:text-white transition">
                  Legal Notice
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={openPreferences}
                  className="hover:text-white transition text-left"
                >
                  Cookie Preferences
                </button>
              </li>
            </ul>
          </div>

            {/* Social */}
            <div>
              <h4 className="font-semibold mb-2 text-base">Follow Us</h4>
              <div className="flex gap-2.5">
                {/* X (Twitter) */}
                <a
                  href="https://x.com/Skillsyncs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-slate-700 transition"
                  aria-label="X (formerly Twitter)"
                  title="Follow us on X"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
                {/* Discord */}
                <a
                  href="https://discord.gg/2tS5GYkAUr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition"
                  aria-label="Discord"
                  title="Join our Discord server"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
                  </svg>
                </a>
                {/* Email */}
                <a
                  href="mailto:skillsyncs@outlook.com"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition"
                  aria-label="Email"
                  title="Send us an email"
                >
                  <Mail className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>

          {/* Copyright Section */}
          <div className="border-t border-slate-800 pt-3 mt-6">
            <div className="flex flex-col items-center gap-1 sm:flex-row sm:justify-center sm:gap-4 text-[11px] sm:text-xs text-white leading-tight">
              <span className="text-slate-300 text-center">
                &copy; {new Date().getFullYear()} SkillSyncs Intelligence. All rights reserved.
              </span>
              <Link
                to="/legal"
                className="text-blue-400 hover:text-blue-300 transition font-semibold"
              >
                Legal Notice
              </Link>
              <button
                type="button"
                onClick={openPreferences}
                className="text-blue-400 hover:text-blue-300 transition font-semibold"
              >
                Cookie Preferences
              </button>
            </div>
          </div>
      </div>
    </footer>
  );
}

export default HomeFooter;

